var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTornadoX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 4L22.6025 4.00488C23.1067 4.05622 23.5 4.48232 23.5 5C23.5 5.51768 23.1067 5.94379 22.6025 5.99512L22.5 6L1.5 6C0.947715 6 0.5 5.55228 0.5 5C0.5 4.44772 0.947715 4 1.5 4L22.5 4Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7L19.1025 7.00488C19.6067 7.05622 20 7.48232 20 8C20 8.51768 19.6067 8.94379 19.1025 8.99512L19 9L5 9C4.44772 9 4 8.55228 4 8C4 7.44772 4.44772 7 5 7L19 7Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10L20.1025 10.0049C20.6067 10.0562 21 10.4823 21 11C21 11.5177 20.6067 11.9438 20.1025 11.9951L20 12L9 12C8.44772 12 8 11.5523 8 11C8 10.4477 8.44772 10 9 10L20 10Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13L18.1025 13.0049C18.6067 13.0562 19 13.4823 19 14C19 14.5177 18.6067 14.9438 18.1025 14.9951L18 15L12 15C11.4477 15 11 14.5523 11 14C11 13.4477 11.4477 13 12 13L18 13Z",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H13C12.4477 18 12 17.5523 12 17C12 16.4477 12.4477 16 13 16H16Z",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 19L13.6025 19.0049C14.1067 19.0562 14.5 19.4823 14.5 20C14.5 20.5177 14.1067 20.9438 13.6025 20.9951L13.5 21H12.5C11.9477 21 11.5 20.5523 11.5 20C11.5 19.4477 11.9477 19 12.5 19H13.5Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTornadoX2);
export default __webpack_public_path__ + "static/media/TornadoX2.26acd8c98ec272b9d401aa29dadbcd9d.svg";
export { ForwardRef as ReactComponent };